<template>
  <div>
    <v-container>
      <v-layout>
        <v-flex>
          <h3 class="headline">User</h3>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn color="primary" @click="showDialog = true"> <v-icon>add</v-icon>Add </v-btn>
        </v-flex>
      </v-layout>

      <template v-for="(user, index) in users">
        <v-card class="mb-2" :key="index + '_' + user.userid">
          <v-layout row>
            <v-flex class="pa-2" grow>
              <v-layout column justify-center fill-height>
                <span>{{ user.userid }}</span>
              </v-layout>
            </v-flex>
            <v-flex class="pa-2 text-xs-center" shrink>
              <v-layout column justify-center fill-height>
                <v-chip round disabled small color="primary" text-color="white">{{
                  user.status
                }}</v-chip>
              </v-layout>
            </v-flex>
            <v-btn fab flat small shrink @click="deleteLeologisticsUsername(user.userid)">
              <v-icon>delete</v-icon>
            </v-btn>
          </v-layout>
        </v-card>
      </template>
    </v-container>

    <v-dialog v-model="showDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">User Profile</span>
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 class="form-control">
              <div class="caption">Userid</div>
              <input type="text" class="form-control" v-model="userid" placeholder="Userid" />
            </v-flex>
            <v-flex xs12 class="form-control">
              <div class="caption">Password</div>
              <input type="text" class="form-control" v-model="password" placeholder="Password" />
            </v-flex>
            <v-flex xs12 class="form-control">
              <div class="caption">Status</div>
              <input type="text" class="form-control" v-model="status" placeholder="Status" />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text class="text-xs-center">
          <v-btn
            color="grey"
            flat
            @click="
              showDialog = false
              resetForm()
            "
            >Cancel</v-btn
          >
          <v-btn color="primary" depressed @click="saveLeologisticsUsername">Save</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  data: () => {
    return {
      users: [],
      showDialog: false,
      userid: '',
      password: '',
      status: ''
    }
  },
  mounted: function () {
    var vm = this
    vm.getLeologisticsUsername().then(function (users) {
      vm.users = users
    })
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    resetForm: function () {
      var vm = this
      vm.userid = ''
      vm.password = ''
      vm.status = ''
    },
    getLeologisticsUsername: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getLeologisticsUsername(null, function (error, response) {
          if (error) {
            console.error(error)
            reject(error)
          }
          resolve(response.data)
        })
      })
    },
    saveLeologisticsUsername: function () {
      var vm = this
      var data = {
        userid: vm.userid,
        password: vm.password,
        status: vm.status
      }
      return new Promise((resolve, reject) => {
        api.saveLeologisticsUsername(data, function (error, response) {
          if (error) {
            console.error(error)
            reject(error)
          }
          vm.users.push({ userid: vm.userid, status: vm.status })
          vm.showDialog = false
          vm.resetForm()
        })
      })
    },
    deleteLeologisticsUsername: function (userid) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          userid: userid,
          pageid: vm.selectedBot.pageid
        }
        vm.$swal
          .fire({
            title: vm.$t('Do you want to delete?'),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
          .then((result) => {
            if (result.value) {
              api.deleteLeologisticsUsername(data, function (error, response) {
                if (error) {
                  console.error(error)
                  reject(error)
                }
                var index = vm.users.findIndex(function (el) {
                  return el.userid == userid
                })
                if (index != -1) {
                  vm.users.splice(index, 1)
                }
                resolve()
              })
            }
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/leologistics/main.vue